import { formatPrice } from '../../config/pricingConfig';

const PRICING_API_BASE = '/api/GetPrices';
const HOURS_PER_MONTH = 730;

async function fetchPrice(filter) {
  try {
    const res = await fetch(`${PRICING_API_BASE}?$filter=${encodeURIComponent(filter)}`);
    if (!res.ok) return null;
    const data = await res.json();
    if (!data.Items || data.Items.length === 0) return null;
    return data.Items[0];
  } catch {
    return null;
  }
}

export async function estimateDesignCosts(nodes) {
  const vmNodes = nodes.filter((n) => n.data?.type === 'virtual-machine');
  const diskNodes = nodes.filter((n) => n.data?.type === 'managed-disk');
  const results = [];

  for (const vm of vmNodes) {
    const sku = vm.data.sku || 'Standard_B2s';
    const region = vm.data.region || 'eastus';
    const filter = `armRegionName eq '${region}' and armSkuName eq '${sku}' and priceType eq 'Consumption' and serviceFamily eq 'Compute'`;
    const item = await fetchPrice(filter);
    const unitPrice = item ? parseFloat(item.unitPrice) : null;
    const monthlyCost = unitPrice ? unitPrice * HOURS_PER_MONTH : null;
    results.push({
      nodeId: vm.id,
      name: vm.data.name,
      type: 'Virtual Machine',
      sku,
      region,
      unitPrice,
      monthlyCost,
      currency: item?.currencyCode || 'USD',
      unitOfMeasure: item?.unitOfMeasure || '1 Hour',
    });
  }

  for (const disk of diskNodes) {
    const diskType = disk.data.diskType || 'Premium_LRS';
    const diskSize = disk.data.diskSize || 128;
    const region = disk.data.region || 'eastus';
    const skuName = diskType.replace('_LRS', '').replace('_ZRS', '');
    const filter = `armRegionName eq '${region}' and serviceName eq 'Storage' and skuName eq '${skuName}' and type eq 'Consumption'`;
    const item = await fetchPrice(filter);
    const unitPrice = item ? parseFloat(item.unitPrice) : null;
    const monthlyCost = unitPrice ? unitPrice * diskSize / 730 : null;
    results.push({
      nodeId: disk.id,
      name: disk.data.name,
      type: 'Managed Disk',
      sku: diskType,
      region,
      unitPrice,
      monthlyCost,
      currency: item?.currencyCode || 'USD',
      unitOfMeasure: '1/Month',
    });
  }

  const totalMonthly = results.reduce((sum, r) => sum + (r.monthlyCost || 0), 0);
  return { items: results, totalMonthly };
}

export { HOURS_PER_MONTH, formatPrice };
